import styled from "styled-components";

const FirstImageContainer = styled.div`
  padding-right: 0.5em !important;

  @media (max-width: 575px) {
    margin-bottom: 10px;
  }
`;
export default FirstImageContainer;
